document.addEventListener("DOMContentLoaded", function () {

    const mainImage = document.getElementById("main-product-image");
    const thumbs = document.querySelectorAll(".single-thumb img");

    const prevBtn = document.getElementById("gallery-prev");
    const nextBtn = document.getElementById("gallery-next");

    let currentIndex = 0;

    // Set initial active thumbnail
    thumbs[0]?.parentElement.classList.add("active");

    function updateGallery(index) {

        currentIndex = index;
        mainImage.style.opacity = "0";
        setTimeout(() => {
            mainImage.src = thumbs[index].dataset.full;
            mainImage.style.opacity = "1";
        }, 150);
        document.querySelectorAll(".single-thumb").forEach((thumb) => {
            thumb.classList.remove("active");
        });
        const wrapper = document.querySelector(".pd-thumb-wrapper");
        const activeThumb = thumbs[index].parentElement;
        activeThumb.classList.add("active");
        if (window.innerWidth <= 768) {
            wrapper.scrollTo({
                left:
                    activeThumb.offsetLeft -
                    wrapper.offsetWidth / 2 +
                    activeThumb.offsetWidth / 2,
                behavior: "smooth"
            });

        } else {
            wrapper.scrollTo({
                top:
                    activeThumb.offsetTop -
                    wrapper.offsetHeight / 2 +
                    activeThumb.offsetHeight / 2,
                behavior: "smooth"
            });

        }
    }

    // Thumbnail Click
    thumbs.forEach((thumb, index) => {

        thumb.addEventListener("click", function () {
            updateGallery(index);
        });

    });

    // Next
    nextBtn.addEventListener("click", function () {

        let nextIndex = currentIndex + 1;

        if (nextIndex >= thumbs.length) {
            nextIndex = 0;
        }

        updateGallery(nextIndex);

    });

    // Previous
    prevBtn.addEventListener("click", function () {

        let prevIndex = currentIndex - 1;

        if (prevIndex < 0) {
            prevIndex = thumbs.length - 1;
        }

        updateGallery(prevIndex);

    });




    // Modal
    const modal = document.querySelector(".gallery-modal");
    const modalImg = document.querySelector(".gallery-modal-image");
    const modalPrev = document.querySelector(".gallery-modal-prev");
    const modalNext = document.querySelector(".gallery-modal-next");
    const modalClose = document.querySelector(".gallery-close");

    mainImage.addEventListener("click", () => {
        modal.classList.add("active");
        modalImg.src = thumbs[currentIndex].dataset.full;
        document.body.style.overflow = "hidden";
    });
    modalClose.addEventListener("click", () => {
        modal.classList.remove("active");
        document.body.style.overflow = "";
    });
    modal.addEventListener("click", (e) => {
        if (e.target === modal) {
            modal.classList.remove("active");
            document.body.style.overflow = "";
        }
    });
    modalNext.addEventListener("click", () => {
        let nextIndex = currentIndex + 1;
        if (nextIndex >= thumbs.length) {
            nextIndex = 0;
        }
        updateGallery(nextIndex);
        modalImg.src = thumbs[nextIndex].dataset.full;
    });
    modalPrev.addEventListener("click", () => {
        let prevIndex = currentIndex - 1;
        if (prevIndex < 0) {
            prevIndex = thumbs.length - 1;
        }
        updateGallery(prevIndex);
        modalImg.src = thumbs[prevIndex].dataset.full;
    });
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            modal.classList.remove("active");
            document.body.style.overflow = "";
        }
    });




    

});



// ZIPCODE CHECKS
document.getElementById("checkPostcodeBtn").addEventListener("click", async function() {
 
    const zip = document
        .getElementById("postcodeInput")
        .value
        .trim();

    const result = document.getElementById("postcodeResult");
    result.style.display = "inline-block";

    if (!zip) {
        result.innerHTML = "Please enter a ZIP code";
        result.style.backgroundColor = "#8000000d";
        result.style.color = "red";
        return;
    }

    result.style.backgroundColor = "#0000000d";
    result.style.color = "#222222";
    result.innerHTML = "Checking...";

  try {

    const response = await fetch(
      `https://api.zippopotam.us/us/${zip}`
    );

    if (!response.ok) {
      throw new Error();
    }

    const data = await response.json();

    const city =
      data.places[0]["place name"];

    const state =
      data.places[0]["state"];

    result.innerHTML =
    `
    
    <div class="first-line">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M22.319 4.431 8.5 18.249a1 1 0 0 1-1.417 0L1.739 12.9a1 1 0 0 0-1.417 0 1 1 0 0 0 0 1.417l5.346 5.345a3.008 3.008 0 0 0 4.25 0L23.736 5.847a1 1 0 0 0 0-1.416 1 1 0 0 0-1.417 0Z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg> Delivery available to ${city}, ${state}
    </div>
    <div class="second-line">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 48 48" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M41.211 37.288a4.112 4.112 0 1 1 4.109-4.112 4.114 4.114 0 0 1-4.109 4.112zm0-6.724a2.612 2.612 0 1 0 2.609 2.612 2.613 2.613 0 0 0-2.609-2.612zM19.542 37.288a4.112 4.112 0 1 1 4.108-4.112 4.115 4.115 0 0 1-4.108 4.112zm0-6.724a2.612 2.612 0 1 0 2.608 2.612 2.614 2.614 0 0 0-2.608-2.612z" fill="#000000" opacity="1" data-original="#000000"></path><path d="M46.621 33.926H44.57a.75.75 0 0 1 0-1.5h1.839v-3.977a3.16 3.16 0 0 0-.4-1.536l-4.06-7.279a.4.4 0 0 0-.349-.205h-5.533v13h1.786a.75.75 0 0 1 0 1.5h-2.536a.75.75 0 0 1-.75-.75v-14.5a.75.75 0 0 1 .75-.75H41.6a1.9 1.9 0 0 1 1.66.974l4.059 7.28a4.662 4.662 0 0 1 .589 2.266v4.19a1.289 1.289 0 0 1-1.287 1.287zM16.183 33.926H8.992a.75.75 0 0 1-.75-.75v-5.768a.75.75 0 0 1 1.5 0v5.018h6.441a.75.75 0 0 1 0 1.5zM8.992 24.747a.75.75 0 0 1-.75-.75v-5.036a.75.75 0 0 1 1.5 0V24a.75.75 0 0 1-.75.747z" fill="#000000" opacity="1" data-original="#000000"></path><path d="M35.317 33.926H22.9a.75.75 0 0 1 0-1.5h11.667V12.805H9.742v3.089a.75.75 0 0 1-1.5 0v-3.227a1.364 1.364 0 0 1 1.363-1.362h25.1a1.364 1.364 0 0 1 1.362 1.362v20.509a.75.75 0 0 1-.75.75zM11.957 28.158H2.438a.75.75 0 0 1 0-1.5h9.519a.75.75 0 0 1 0 1.5z" fill="#000000" opacity="1" data-original="#000000"></path><path d="M19.542 24.747H6.259a.75.75 0 0 1 0-1.5h13.283a.75.75 0 0 1 0 1.5zM5.846 20.787H.659a.75.75 0 1 1 0-1.5h5.187a.75.75 0 0 1 0 1.5zM14.163 16.644H5.007a.75.75 0 1 1 0-1.5h9.156a.75.75 0 0 1 0 1.5z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg> Estimated delivery: 3–5 business days
    </div>
    `;

    result.style.backgroundColor = "#5180000d";
    result.style.color = "green";

  } catch (e) {

    result.style.backgroundColor = "#8000000d";
    result.style.color = "red";
    result.innerHTML ="✗ Invalid ZIP code";
    

  }

});




document.addEventListener("DOMContentLoaded", () => {

    const paymentTerms =
    document.querySelector("shopify-payment-terms");

    const style =
    document.createElement("style");

    style.textContent = `
    #shopify-installments p{
        padding:8px 0px !important;
        border-radius:8px !important;
        text-transform: uppercase !important;
        font-weight: 500 !important;
        letter-spacing: 1px !important;
        font-size: 11px !important;
        color: #a5a5a5 !important;
        margin-top: 7px !important;
    }
    `;
    paymentTerms.shadowRoot.appendChild(style);

});


// JUDGE ME REVIEW SECTION CSS
document.addEventListener("DOMContentLoaded", () => {

    const observer = new MutationObserver(() => {

        if(!document.querySelector(".jm-stack")) return;

        const style =
        document.createElement("style");

        style.textContent = `
            .jm-stack{
                padding-top:0px !important;
            }
            .jm-review-widget-minimal-header {
                margin-bottom: 40px;
            }
        `;

        document.head.appendChild(style);

        observer.disconnect();

    });

    observer.observe(document.body,{
        childList:true,
        subtree:true
    });

});




document.addEventListener("DOMContentLoaded", () => {

    const tabButtons =
    document.querySelectorAll(".tab-btn");

    const tabPanes =
    document.querySelectorAll(".tab-pane");

    const indicator =
    document.querySelector(".tab-indicator");

    function moveIndicator(button){

        if(!indicator) return;

        indicator.style.width =
        button.offsetWidth + "px";

        indicator.style.left =
        button.offsetLeft + "px";

    }

    const activeBtn =
    document.querySelector(".tab-btn.active");

    if(activeBtn){
        moveIndicator(activeBtn);
    }

    tabButtons.forEach(button => {

        button.addEventListener("click", () => {

            const target =
            button.dataset.tab;

            tabButtons.forEach(btn => {
                btn.classList.remove("active");
            });

            tabPanes.forEach(tab => {
                tab.classList.remove("active");
            });

            button.classList.add("active");

            const targetPane =
            document.getElementById(target);

            if(targetPane){
                targetPane.classList.add("active");
            }

            moveIndicator(button);

        });

    });

});





// faq

document.addEventListener("DOMContentLoaded", () => {

    const faqItems =
    document.querySelectorAll(".faq-item");

    faqItems.forEach(item => {

        const button =
        item.querySelector(".faq-question");

        const answer =
        item.querySelector(".faq-answer");

        button.addEventListener("click", () => {

            const isOpen =
            item.classList.contains("active");

            faqItems.forEach(faq => {

                faq.classList.remove("active");

                faq.querySelector(".faq-answer")
                   .style.maxHeight = null;

            });

            if(!isOpen){

                item.classList.add("active");

                answer.style.maxHeight =
                answer.scrollHeight + "px";

            }

        });

    });

});




// share
document.addEventListener("DOMContentLoaded", () => {

    const url =
    encodeURIComponent(window.location.href);

    document.querySelector(".share-facebook").href =
    `https://www.facebook.com/sharer/sharer.php?u=${url}`;

    document.querySelector(".share-twitter").href =
    `https://twitter.com/intent/tweet?url=${url}`;

    document.querySelector(".share-whatsapp").href =
    `https://wa.me/?text=${url}`;

    document.querySelector(".copy-link")
    .addEventListener("click", async () => {

        await navigator.clipboard.writeText(
            window.location.href
        );

        alert("Link has been copied! Ready to share");

    });

});